import React, { useState, useEffect, useRef } from 'react';

import {
  Dialog,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  Chip,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import DialogActions2 from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import { useSnackbar } from 'notistack';

import { createAPI, updateAPI, getListAllAPI } from '../../services';

import { DialogoConfirmacao } from '..';

import { FormProvider, useForm } from '../modulo-gerencial-formularios';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const useStylesTitle = makeStyles((theme) => ({
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5), // Espaço entre ícone/texto
  },
  badge: {
    fontWeight: 'bold',
    color: 'white',
    height: '24px',
    fontSize: '0.7rem',
    borderRadius: '6px',
    border: '1px solid rgba(255,255,255,0.4)',
  },
  createBadge: {
    backgroundColor: '#28a745', // Verde para Novo
  },
  editBadge: {
    backgroundColor: '#ff9800', // Laranja para Edição
  },
  titleText: {
    fontWeight: 600,
  },
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, isClose, isEdit, compacto, ...other } = props;
  const { handleClose } = useForm();
  const classesTitle = useStylesTitle();

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className={classesTitle.titleContainer}>
        <Chip
          size="small"
          label={isEdit ? 'EDIÇÃO' : 'NOVO'}
          icon={
            isEdit ? (
              <EditIcon style={{ color: 'white', fontSize: 16 }} />
            ) : (
              <AddCircleIcon style={{ color: 'white', fontSize: 16 }} />
            )
          }
          className={`${classesTitle.badge} ${
            isEdit ? classesTitle.editBadge : classesTitle.createBadge
          }`}
        />
        <Typography
          variant={compacto ? 'subtitle1' : 'h6'}
          noWrap={compacto}
          style={{
            fontWeight: 'bold',
            ...(compacto ? { paddingRight: 40 } : {}),
          }}
          className={classesTitle.titleText}
        >
          {children}
        </Typography>
      </div>
      {isClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    /* borderRadius: '25px',
    width: '150px', */
  },
  btnAtionsDisabled: {
    /* borderRadius: '25px',
    width: '150px', */
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  btnCustom: {
    borderRadius: '10px',
    //width: '150px',
    fontWeight: 'bold',
    // Personalização de cor:
    backgroundColor: '#28a745', // Verde customizado
    color: '#fff',
    '&:hover': {
      backgroundColor: '#218838', // Cor ao passar o mouse
    },
  },
  btnCancelar: {
    fontWeight: 'bold',
    color: '#757575', // Cinza mais elegante
    '&:hover': {
      color: '#d32f2f', // Fica vermelho só no hover
    },
  },
  rootTitle: {
    margin: 0,
    padding: theme.spacing(2, 3),
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    // Transição suave quando o ID muda
    transition: 'background 0.4s ease-in-out',
  },
  // Background para CRIAÇÃO
  bgCreate: {
    background: 'linear-gradient(45deg, #009FD4 30%, #00C9FF 90%)',
    boxShadow: '0 3px 5px rgba(0, 159, 212, 0.3)',
  },
  // Background para EDIÇÃO
  bgEdit: {
    background: 'linear-gradient(45deg, #009FD4 30%, #00C9FF 90%)',
    boxShadow: '0 3px 5px rgba(0, 159, 212, 0.3)',
  },
  paper: {
    borderRadius: 16,
    //padding: theme.spacing(1),
  },
  // Tela cheia (celular): sem cantos arredondados.
  paperTelaCheia: {
    borderRadius: 0,
  },
}));

// `telaCheia` (celular): botões grandes, lado a lado, sem os atalhos do teclado nos textos.
function DialogActions({ telaCheia = false }) {
  const classes = useStyles();
  const {
    handleSubmit,
    handleClose,
    formState,
    subscribeFormState,
  } = useForm();
  const [, forceUpdate] = useState({});

  useEffect(() => {
    const unsub = subscribeFormState(() => {
      forceUpdate({});
    });

    return unsub;
  }, []);

  return (
    <DialogActions2
      style={
        telaCheia
          ? {
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: 16,
              padding: '12px 20px calc(12px + env(safe-area-inset-bottom))',
            }
          : { display: 'flex', justifyContent: 'space-between' }
      }
    >
      <Button
        onClick={() => {
          handleClose();
        }}
        //variant="contained"
        className={classes.btnCancelar}
        style={
          telaCheia
            ? { minHeight: 48, margin: 0, border: '1px solid #d0d5dd' }
            : undefined
        }
        tabIndex={-1}
      >
        {telaCheia ? 'Cancelar' : 'Cancelar (F4)'}
      </Button>
      <Button
        //variant="contained"
        variant="contained"
        className={classes.btnCustom}
        style={telaCheia ? { minHeight: 48, margin: 0 } : undefined}
        onClick={() => {
          handleSubmit();
        }}
        disabled={formState.isError}
        /* classes={{
          root: classes.btnAtions,
          disabled: classes.btnAtionsDisabled,
        }} */
        tabIndex={-1}
      >
        {telaCheia ? 'Salvar' : 'Salvar (F8)'}
      </Button>
    </DialogActions2>
  );
}

const DialogoCreateEdit = ({
  open,
  onClose = () => {},
  id,
  initialValues,
  validators,
  resource,
  resourceCreate,
  resourceUpdate,
  resourceGet,
  nested = [],
  titleCreate,
  titleUpdate,
  children,
  transformSalvar = (dados) => dados,
  transformGetDados = (dados) => dados,
  config = {},
  isCloseTitle = false,
  dialogProps = {
    fullWidth: true,
    maxWidth: 'sm',
  },
  isDialogoConfirmacaoActions = true,
  getMensagemConfirmacao,
  aposSalvar,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const isEdit = Boolean(id);
  const [dados, setDados] = useState({
    carregando: true,
    initialValues: {},
  });

  function closeLocal() {
    onClose();
    setDados({
      carregando: true,
      initialValues: {},
    });
  }

  // Evita salvar duas vezes (duplo clique em "Sim" da confirmação, F8 + clique):
  // enquanto uma chamada está em andamento, as demais são ignoradas.
  const salvandoRef = useRef(false);

  async function handleSalvar(data) {
    if (salvandoRef.current) return;
    salvandoRef.current = true;
    try {
      if (isEdit) {
        const response = await updateAPI(
          resourceUpdate ? resourceUpdate : resource,
          id,
          transformSalvar(data),
        );
        const { status, message } = response.data;
        if (status) {
          enqueueSnackbar(message, {
            variant: 'success',
          });
          if (aposSalvar) await aposSalvar(response.data, data);
          closeLocal();
        } else {
          enqueueSnackbar(message, {
            variant: 'error',
          });
        }
      } else {
        const response = await createAPI(
          resourceCreate ? resourceCreate : resource,
          transformSalvar(data, config),
        );
        const { status, message } = response.data;
        if (status) {
          enqueueSnackbar(message, {
            variant: 'success',
          });
          if (aposSalvar) await aposSalvar(response.data, data);
          closeLocal();
        } else {
          enqueueSnackbar(message, {
            variant: 'error',
          });
        }
      }
    } catch (e) {
      const error = e ? e.toString() : 'ERROR';
      enqueueSnackbar(error, {
        variant: 'error',
      });
    } finally {
      salvandoRef.current = false;
    }
  }

  async function getDataResource(id) {
    try {
      const data = await getListAllAPI(
        resourceGet ? resourceGet : resource,
        ['id', 'asc'],
        { id: [id] },
        nested,
      );
      if (data.data.length > 0) {
        setDados({
          carregando: false,
          initialValues: transformGetDados(data.data[0], config),
        });
      } else {
        throw 'Erro Inesperado contate o desenvolvedor!';
      }
    } catch (e) {
      const error = e ? e.toString() : 'ERROR';
      enqueueSnackbar(error, {
        variant: 'error',
      });
      closeLocal();
    }
  }

  useEffect(() => {
    if (open) {
      if (!isEdit) {
        setDados({
          carregando: false,
          initialValues,
        });
      } else {
        getDataResource(id);
      }
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableBackdropClick
      disableEscapeKeyDown
      classes={{
        paper: dialogProps.fullScreen ? classes.paperTelaCheia : classes.paper,
      }}
      {...dialogProps}
    >
      {!dados.carregando ? (
        <FormProvider
          initialValues={dados.initialValues}
          validators={validators}
          handleClose={closeLocal}
          handleSalvar={handleSalvar}
          config={{ isEdit, ...config }}
          isDialogoConfirmacaoActions={isDialogoConfirmacaoActions}
          ConfirmacaoComponent={DialogoConfirmacao}
          getMensagemConfirmacao={getMensagemConfirmacao}
        >
          <DialogTitle
            isEdit={isEdit}
            isClose={isCloseTitle}
            /* style={{
              backgroundColor: isEdit ? '#007ca5' : '#009FD4', // Escurece um pouco se for edição
              transition: 'background-color 0.3s ease',
            }} */
            /* style={{ backgroundColor: '#009FD4', color: 'white' }} */
            compacto={Boolean(dialogProps.fullScreen)}
            className={`${classes.root} ${
              isEdit ? classes.bgEdit : classes.bgCreate
            }`}
          >
            {id ? titleUpdate : titleCreate}
          </DialogTitle>
          <DialogContent
            dividers
            style={dialogProps.fullScreen ? { padding: '8px 12px' } : undefined}
          >
            <div style={{ height: '100%' }}>{children}</div>
          </DialogContent>
          <DialogActions telaCheia={Boolean(dialogProps.fullScreen)} />
        </FormProvider>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '300px',
          }}
        >
          <CircularProgress />
        </div>
      )}
    </Dialog>
  );
};

export default DialogoCreateEdit;
